<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <MHeader v-if="$root.isMobile"></MHeader>
      <JwHeader v-else></JwHeader>
      <section class="jw-container">
        <router-view />
      </section>
      <MFooter v-if="$root.isMobile"></MFooter>
      <JwFooter v-else></JwFooter>
    </div>
  </a-config-provider>
</template>

<script>
import JwHeader from '@/components/header'
import JwFooter from '@/components/footer'
import MHeader from '@/mobile/header'
import MFooter from '@/mobile/footer'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import enUS from 'ant-design-vue/lib/locale-provider/en_US'
export default {
  components: {
    JwHeader,
    JwFooter,
    MHeader,
    MFooter
  },

  data () {
    return {
      locale: this.getLocale()
    }
  },

  methods: {
    getLocale () {
      const languageMap = {
        'zh-CN': zhCN,
        'en-US': enUS
      }

      const language = localStorage.getItem('jw-locale')

      return languageMap[language] || zhCN
    }
  }
}
</script>

<style>
  #app {
    font-family: Helvetica, Arial, Avenir, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2E3635;
    height: 100%;
    /* overflow: auto; */
    font-size: 14px;
  }
  .jw-container {
    min-height: calc(100% - 200px);
    border-top: 3px solid #e2e2e2;
  }

  @media (min-width: 576px) {
    html {
      font-size: 10px;
    }
  }

  @media (min-width: 768px) {
    html {
      font-size: 11px;
    }
  }

  @media (min-width: 1024px) {
    html {
      font-size: 12px;
    }
  }

  @media (min-width: 1280px) {
    html {
      font-size: 13px;
    }
  }

  @media (min-width: 1360px) {
    html {
      font-size: 14px;
    }
  }

  @media (min-width: 1680px) {
    html {
      font-size: 16px;
    }
  }
</style>
